import React from "react";
import "../assets/css/Footer.css";
import TwitterIcon from "@mui/icons-material/Twitter";
import logo from "../assets/images/logo.png";
import TelegramIcon from "@mui/icons-material/Telegram";
import medium from "../assets/images/medium.png";

function Footer() {
  return (
    <div style={{ backgroundColor: "rgba(0,0,0,0.3)" }} className="Footer">
      <div className="footer__row">
        <div className="footer__col">
          <div className="col__logo">
            <img src={logo} className="col__logoImg" alt="logo" />
          </div>
          <div className="col__head">GODZILLA PROJECT</div>
        </div>
        <div className="footer__col num-1">
          <div className="col__handles">
            <a href="https://twitter.com/Godzilla_io">
              <TwitterIcon
                sx={{
                  fontSize: "50px",
                }}
                color="white"
              />
            </a>
            <a href="https://t.me/Godzilla_io">
              <TelegramIcon
                sx={{
                  fontSize: "50px",
                }}
                color="white"
              />
            </a>
            <a href="https://medium.com/@Godzilla_io">
              <img
                style={{ width: "50px", height: "50px" }}
                src={medium}
                alt="logo"
              />
            </a>
          </div>
          <div className="col__desc">Subscribe to our social media</div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
